module.exports = __webpack_public_path__ + "img/bcio.835d642f.svg";